import { AttachInternals, Component, Element, Event, EventEmitter, h, Host, Prop } from '@stencil/core'

import { CssClassMap } from '../../../utils/interfaces'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/menu-header?tab=designer).
 *
 * @slot logo - Slot para logo personalizado no cabeçalho.
 * @slot signature - Slot para a assinatura personalizada do sistema.
 */
@Component({
  tag: 'br-menu-header',
  styleUrl: 'menu-header.scss',
  shadow: true,
})
export class MenuHeader {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrMenuHeaderElement

  @AttachInternals() elementInternals: ElementInternals

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = `br-menu-${MenuHeaderId++}`

  /**
   * URL da imagem do logo no cabeçalho do menu
   */
  @Prop({ reflect: true }) logoSrc?: string

  /**
   * Texto alternativo para a imagem do logo
   */
  @Prop({ reflect: true }) logoAlt: string = 'Logo'

  /**
   * Texto de identificação do site ou sistema
   */
  @Prop({ reflect: true }) signature?: string

  /**
   * Evento emitido quando o botão de fechar é clicado
   */
  @Event() brMenuHeaderClose: EventEmitter<void>

  /**
   * Manipula o clique no botão de fechar
   */
  private handleCloseClick = () => {
    this.brMenuHeaderClose.emit()
  }

  private getCssClassMap(): CssClassMap {
    return {
      'menu-header': true,
    }
  }

  render() {
    return (
      <Host>
        <div class={this.getCssClassMap()}>
          <div class="menu-title">
            <slot name="logo">{this.logoSrc && <img src={this.logoSrc} alt={this.logoAlt} />}</slot>
            <slot name="signature">{this.signature && <span>{this.signature}</span>}</slot>
          </div>
          <div class="menu-close">
            <br-button aria-label="Fechar o menu" shape="circle" onClick={this.handleCloseClick} data-dismiss="menu">
              <br-icon icon-name="fa6-solid:xmark"></br-icon>
            </br-button>
          </div>
        </div>
      </Host>
    )
  }
}

let MenuHeaderId = 0
